import APIs from '../../api'
import { apiClient } from '../../api/client'

export const commonApis = {
  getUserProfile: async () => {
    const response = await apiClient.get('/users/me')
    return response.data
  },

  uploadFile: async (file, folder = 'general') => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('folder', folder)
    const response = await apiClient.post('/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  },

  getCountries: async () => {
    const response = await apiClient.get('/countries')
    return response.data
  },

  getCurrencies: async () => {
    const response = await apiClient.get('/currencies')
    return response.data
  },

  getSettings: async () => {
    const response = await apiClient.get('/settings')
    return response.data
  },

  updateSettings: async (data) => {
    const response = await apiClient.put('/settings', data)
    return response.data
  },

  // Notifications — hits the guardian backend directly via APIs.NOTIFICATIONS
  // rather than the generic `apiClient` base URL. The generic client is wired
  // to `VITE_API_BASE_URL` (a separate service in dev); notifications live
  // with the rest of the alarm + facility endpoints so the inbox always
  // hits the same backend as the page that surfaces the event. Passing an
  // absolute URL into `apiClient.get` works because axios honours absolute
  // URLs in place of the baseURL.
  getNotifications: async (params = {}) => {
    const response = await apiClient.get(APIs.NOTIFICATIONS.list, { params })
    return response.data
  },

  markNotificationRead: async (id) => {
    const response = await apiClient.put(APIs.NOTIFICATIONS.markRead(id))
    return response.data
  },
}
